///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case = abcsetup.set_case || {};
abcsetup.set_case.common = abcsetup.set_case.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case.common = {
    bindFields: function () {
        window.addEventListener('close-email-modal', () => {
            $('#emailModal').modal('hide');
            abcsetup.alerts.flashMessage('E-mail successfully sent', 'success');
        });

        $(document).on('change', '#app_models_s_e_t_case_case_details_case_details_set_case_type_id', function () {
            Livewire.emit('typeChanged', $(this).val());
        });

        $(document).on('change', '#app_models_s_e_t_case_response_supplier_information_supplier_information_submission_options', function () {
            Livewire.emit('submissionOptionChanged', $(this).val());
        });

        // Pop the warning modal when the user focuses on the external message textarea
        $(document).on('focus', 'div.messages div.external:not(.warned) textarea.message', function () {
            $('div.messages div.external').addClass('warned');
            $('#warning-modal').modal('show');
        });

        // Bind the contributor select2
        Livewire.on('contributorAdded', function() {
            $(".contributor-select").val('').trigger('change');
        })

        // If the contract is set to extend, validate that the user updates the dates
        Livewire.on('extendPricingChanged', function(table, row, extend) {
            const inputClass = table + '-' + row;
            $('input.' + inputClass).remove();
            $('form.set-form').prepend('<input type="hidden" class="extend_validations ' + inputClass + '" value="' + extend + '">');
        });

        Livewire.on('recentCasesUpdated', function(count) {
            $('#submitModal .modal-dialog').toggleClass('modal-lg', count !== 0);
        })

        // Validate the contract fields, then the rest of the form
        $('.btn-validator, .btn-submit').on('click', function () {
            // Check if all "extend pricing" contracts/memberships have had dates updated
            // We have to do it in an async function because we're showing multiple alert modals
            new Promise((resolve, reject) => {
                if ($('input.extend_validations[value="1"]').length > 0) {
                    abcsetup.alerts.confirm('Confirm Submission', 'It looks like one or more Contract Detail or Membership Validation Contract dates have remained unchanged. Are you sure you want to proceed with these dates?', function (resp) {
                        if (!resp) {
                            reject('User cancelled submission');
                        } else {
                            resolve('User confirmed submission');
                        }
                    });
                } else {
                    resolve('Extend pricing validations not required');
                }
            }).then(() => {
                // Validate the form if there are fields to validate
                let formValid = $('form.set-form input').length > 0
                    ? fieldValidate.checkValidity($('form.set-form'))
                    : true;

                // Check for errors on the form
                if (formValid && $('.contract-table .is-invalid').length == 0) {
                    if ($(this).hasClass('btn-submit')) {
                        $('#submitModal').modal('show');
                    } else {
                        abcsetup.alerts.show('Form Validation', 'All fields on this form have passed validation');
                    }
                } else {
                    abcsetup.alerts.show('Form Validation', 'There are errors on this form. Please review the fields highlighted in red');
                }
            });
        });

        // Block the UI on submit to prevent double-clicking
        $(document).on('click', '#submitModal .btn-primary', function () {
            abcsetup.blockUI(true);
        });
    },

    fieldError: function() {
        abcsetup.unblockUI();

        // If there are no errors on the modal, close it
        if ($('#submitModal .errorMsg').length == 0) {
            $('#submitModal').modal('hide');
        }
    },
}